export enum ClothingStyle {
  SCHOOL = 'school',
  CASUAL = 'casual',
  DATE = 'date',
  STAR_TREK = 'startrek',
}
